import { AppVersionResponseSchema } from './app-version.schema';
/**
 * App Version Endpoint Contract
 * Returns the current backend version and build info
 */ export const appVersionContract = {
    method: 'GET',
    path: '/api/v2/version',
    description: 'Returns the current backend version and build info',
    responseSchema: AppVersionResponseSchema,
    statusCodes: {
        success: 200,
        errors: {}
    }
};

//# sourceMappingURL=app-version.contract.js.map